import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-need-billing-address',
  templateUrl: './need-billing-address.component.html',
  styleUrls: ['./need-billing-address.component.css']
})
export class NeedBillingAddressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
